"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var InputRow_1 = require("../../components/InputRow");
var utils_1 = require("../../utils");
var Prompt_1 = require("../../components/Prompt");
var CityPop_1 = require("../../components/CityPop");
var ProductPop_1 = require("../ProductPop");
var request_1 = require("../../utils/request");
var appMethods_1 = require("../../appMethods");
var tools_1 = require("../../utils/tools");
/** 车型信息组件 */
var productArea_1 = __importDefault(require("./productArea"));
var successCom_1 = __importDefault(require("./successCom"));
var modal_1 = __importDefault(require("./modal"));
var autoHooks_1 = require("../../utils/autoHooks");
var commonData_1 = require("./commonData");
var urlMethod_1 = require("../../utils/urlMethod");
var newcarCommonApis_1 = require("../../utils/newcarCommonApis");
var testParam_1 = require("./testParam");
var crypto_1 = require("../../utils/crypto");
/**
 * 安卓6及以下版本58app不兼容crypto，会造成页面白屏，所以在其环境下直接跳转到询价页面
 */
var isLowerAndroidApp = tools_1.isLowerAndroid() && (appMethods_1.appMethods.getAppType() != "browser");
var Index = react_1.forwardRef(function (props, ref) {
    var _a;
    react_1.useImperativeHandle(ref, function () {
        return {
            // 向外曝漏关闭弹窗事件，内置事件会处理formdata的相关操作，如果是在自定义组件的时候要关闭弹窗需要使用这个方法
            onCloseModal: onClickClose,
        };
    });
    var cookieDomainName = react_1.useMemo(function () {
        return props.cookieDomain || '58che.com';
    }, [props.cookieDomain]);
    var visible = react_1.useMemo(function () { return props.visible; }, [props.visible]);
    /* 弹窗禁止展示的模块  */
    var bannedDisplayModule = react_1.useMemo(function () {
        return props.bannedDisplayModule ||
            [
            // "name",
            // "tel",
            // "privacy"
            // "submit",
            // "code"
            ];
    }, [props.bannedDisplayModule]);
    /** 是否勾选隐私协议的接口相关信息 */
    var isNeedCodeRelate = react_1.useMemo(function () {
        var _a, _b;
        return {
            ajaxUrl: typeof ((_a = props.isNeedCodeRelate) === null || _a === void 0 ? void 0 : _a.ajaxUrl) !== 'undefined'
                ? props.isNeedCodeRelate.ajaxUrl
                : '',
            ajaxParams: typeof ((_b = props.isNeedCodeRelate) === null || _b === void 0 ? void 0 : _b.ajaxParams) !== 'undefined'
                ? props.isNeedCodeRelate.ajaxParams
                : {},
        };
    }, [props.isNeedCodeRelate]);
    /** 当前的车型相关信息 */
    var prodInfoRelate = react_1.useMemo(function () {
        var _a;
        var prodInfo = {
            defaultProdInfo: typeof ((_a = props.prodInfoRelate) === null || _a === void 0 ? void 0 : _a.defaultProdInfo) !== 'undefined'
                ? props.prodInfoRelate.defaultProdInfo
                : '',
            showProdArea: typeof props.prodInfoRelate !== 'undefined' &&
                typeof props.prodInfoRelate.showProdArea === 'boolean'
                ? props.prodInfoRelate.showProdArea
                : false,
            lineId: (typeof props.prodInfoRelate !== 'undefined' &&
                props.prodInfoRelate.lineId) ||
                '',
            productId: (typeof props.prodInfoRelate !== 'undefined' &&
                props.prodInfoRelate.productId) ||
                '',
            /** 是否显示切换车型标志，默认不显示 */
            showSelectPop: typeof props.prodInfoRelate !== 'undefined' &&
                typeof props.prodInfoRelate.showSelectPop === 'boolean'
                ? props.prodInfoRelate.showSelectPop
                : false,
            /** 自定义点击车型事件 */
            autoClickPro: typeof props.prodInfoRelate !== 'undefined' &&
                typeof props.prodInfoRelate.autoClickPro !== 'undefined'
                ? props.prodInfoRelate.autoClickPro
                : null,
            ajaxUrl: (typeof props.prodInfoRelate !== 'undefined' &&
                props.prodInfoRelate.ajaxUrl) ||
                '',
            saveKey: (typeof props.prodInfoRelate !== 'undefined' &&
                props.prodInfoRelate.saveKey) ||
                '',
            otherOpts: (typeof props.prodInfoRelate !== 'undefined' &&
                props.prodInfoRelate.otherOpts) ||
                {},
        };
        if (typeof props.prodInfoRelate !== 'undefined' &&
            typeof props.prodInfoRelate.selectProdCallback !== 'undefined') {
            prodInfo.selectProdCallback = props.prodInfoRelate.selectProdCallback;
        }
        return prodInfo;
    }, [JSON.stringify(props.prodInfoRelate)]);
    /** 提交成功相关 有Node格式的数据不能JSON.stringfy() */
    var successRelate = react_1.useMemo(function () {
        return {
            showSuccessIcon: typeof props.successRelate !== 'undefined' &&
                typeof props.successRelate.showSuccessIcon === 'boolean'
                ? props.successRelate.showSuccessIcon
                : true,
            successTitle: (typeof props.successRelate !== 'undefined' &&
                props.successRelate.successTitle) ||
                '提交成功',
            // 如果传空字符串意味着不显示 二级标题 所以加上判断是否是undefined
            successSubTitle: typeof props.successRelate !== 'undefined' &&
                typeof props.successRelate.successSubTitle !== 'undefined'
                ? props.successRelate.successSubTitle
                : '平台优先为您匹配合适经销商 </br> 经销商销售会及时与您联系，请保持电话畅通',
            successBtnTitle: typeof props.successRelate !== 'undefined' &&
                props.successRelate.successBtnTitle
                ? props.successRelate.successBtnTitle
                : '我知道了',
            successComNode: (typeof props.successRelate !== 'undefined' &&
                props.successRelate.successComNode) ||
                undefined,
            successMidSlot: (typeof props.successRelate !== 'undefined' &&
                props.successRelate.successMidSlot) ||
                undefined,
            // 如果是成功之后再次打开是否显示成功之后的样式，默认为显示初始化的样式
            successAfterReshowSuccess: typeof props.successRelate !== 'undefined' &&
                typeof props.successRelate.successAfterReshowSuccess === 'boolean'
                ? props.successRelate.successAfterReshowSuccess
                : false,
        };
    }, [props.successRelate]);
    /** title相关 */
    var titleRelate = react_1.useMemo(function () {
        return __assign(__assign({}, (props.titleRelate || {})), { mainTitle: typeof props.titleRelate.mainTitle !== 'undefined'
                ? props.titleRelate.mainTitle
                : '', subTitle: typeof props.titleRelate.subTitle !== 'undefined'
                ? props.titleRelate.subTitle
                : '', btnSubTitle: typeof props.titleRelate.btnSubTitle !== 'undefined'
                ? props.titleRelate.btnSubTitle
                : '', btnMainTitle: typeof props.titleRelate.btnMainTitle !== 'undefined'
                ? props.titleRelate.btnMainTitle
                : '', mainTitleShow: typeof props.titleRelate.mainTitleShow !== 'undefined'
                ? props.titleRelate.mainTitleShow
                : true });
    }, [JSON.stringify(props.titleRelate)]);
    /** 隐私协议弹窗相关内容 */
    var privacyModalRelate = react_1.useMemo(function () {
        return props.privacyModalRelate;
    }, [JSON.stringify(props.privacyModalRelate)]);
    /** modal容器类名 */
    var modalCn = react_1.useMemo(function () { return props.modalCn; }, [props.modalCn]);
    /** 内容区的类名 */
    var contentCn = react_1.useMemo(function () { return props.contentCn; }, [props.contentCn]);
    /** 是否允许点击遮罩关闭弹窗 */
    var allowMaskClose = react_1.useMemo(function () { return props.allowMaskClose; }, [props.allowMaskClose]);
    /** 是否显示关闭图标 */
    var showCloseIcon = react_1.useMemo(function () { return props.showCloseIcon; }, [props.showCloseIcon]);
    /** 顶部的插槽 有的话就不显示车型信息了 */
    var topSlotNode = react_1.useMemo(function () { return props.topSlotNode; }, [props.topSlotNode]);
    /** 中间插槽 */
    var midSlotNode = react_1.useMemo(function () { return props.midSlotNode; }, [props.midSlotNode]);
    /** 验证码相关 */
    var messageCodeRelate = react_1.useMemo(function () {
        return __assign(__assign({}, (props.messageCodeRelate || {})), { needMsgCode: typeof props.messageCodeRelate !== 'undefined' &&
                typeof props.messageCodeRelate.needMsgCode !== 'undefined'
                ? props.messageCodeRelate.needMsgCode
                : 1, ajaxUrl: (typeof props.messageCodeRelate !== 'undefined' &&
                props.messageCodeRelate.ajaxUrl) ||
                newcarCommonApis_1.apiList.sendMsCodeApi, ajaxParams: (typeof props.messageCodeRelate !== 'undefined' &&
                props.messageCodeRelate.ajaxParams) ||
                {} });
    }, [JSON.stringify(props.messageCodeRelate)]);
    /** 提交询价相关 */
    var submitRelate = react_1.useMemo(function () {
        return {
            ajaxUrl: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxUrl) ||
                newcarCommonApis_1.apiList.commonAskPriceApi,
            /** 询价接口所需的额外参数，有默认的传递参数 */
            ajaxParams: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxParams) ||
                {},
            ajaxSubmitContentType: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxSubmitContentType) ||
                'formdata',
            ajaxType: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxType) ||
                'json',
            ajaxMethod: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxMethod) ||
                'post',
            onSubmitSuccessFn: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.onSubmitSuccessFn) ||
                undefined,
            onSubmitErrorFn: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.onSubmitErrorFn) ||
                undefined,
            onSubmitCheckedFn: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.onSubmitCheckedFn) ||
                undefined,
            ajaxOtherParam: (typeof props.submitRelate !== 'undefined' &&
                props.submitRelate.ajaxOtherParam) ||
                {},
        };
    }, [JSON.stringify(props.submitRelate)]);
    /** 城市相关 */
    var cityRelate = react_1.useMemo(function () { return props.cityinfoRelate; }, [JSON.stringify(props.cityinfoRelate)]);
    /** 隐私协议相关 */
    var privacyRelate = react_1.useMemo(function () { return props.privacyRelate; }, [props.privacyRelate]);
    var askPriceNameCookieKey = react_1.useMemo(function () { return props.askPriceNameCookieKey || 'askPriceName'; }, [props.askPriceNameCookieKey]);
    var askPricePhoneCookieKey = react_1.useMemo(function () { return props.askPricePhoneCookieKey || 'askPricePhone'; }, [props.askPricePhoneCookieKey]);
    /** 默认的手机号内容 */
    var defaultPhoneValProps = react_1.useMemo(function () { return props.defaultPhoneVal || ''; }, [props.defaultPhoneVal]);
    /** 手机号是否默认中间以****显示 */
    var defaultPhoneEncrption = react_1.useMemo(function () {
        return props.defaultPhoneEncrption || false;
    }, [props.defaultPhoneEncrption]);
    /** 默认的姓名内容 */
    var defaultNameValProps = react_1.useMemo(function () { return props.defaultNameVal || ''; }, [props.defaultNameVal]);
    /** 在app内时，是否要默认显示登录用户的信息 */
    var isUsedAppInfo = react_1.useMemo(function () {
        return typeof props.isUsedAppUserInfo === 'boolean'
            ? props.isUsedAppUserInfo
            : true;
    }, [props.isUsedAppUserInfo]);
    /** 管理所有的form相关数据，tel、name、msgcode、privacy */
    var _b = __read(autoHooks_1.useStateRef({}), 3), formData = _b[0], setFormData = _b[1], formDataRef = _b[2];
    /** 是否显示成功弹窗 */
    var _c = __read(react_1.useState(false), 2), showSuccessCom = _c[0], setShowSuccessCom = _c[1];
    /** 是否展示同意隐私协议的弹窗 */
    var _d = __read(react_1.useState(false), 2), showAgreePrivacy = _d[0], setShowAgreePrivacy = _d[1];
    /** 提交状态 */
    var _e = __read(autoHooks_1.useStateRef(false), 3), submitLoding = _e[0], setSubmitLoding = _e[1], submitLoadingRef = _e[2];
    /** 控制显示发送验证码 */
    var _f = __read(react_1.useState(false), 2), showMsgCode = _f[0], setShowMsgCode = _f[1];
    /** 错误提示显示 */
    var _g = __read(react_1.useState(false), 2), promptShow = _g[0], setPromptShow = _g[1];
    /* 错误提示弹窗的内容 */
    var _h = __read(react_1.useState(''), 2), promptTip = _h[0], setPromptTip = _h[1];
    /* 控制城市弹窗的显示 */
    var _j = __read(react_1.useState(false), 2), cityPopShow = _j[0], setCityPopShow = _j[1];
    /** 如果在qpp的话获取app的参数 */
    var _k = __read(react_1.useState({
        xxwxtokenp: '',
        xxwxtoken: '',
        os: '',
        version: '',
        productorid: '',
        accessmode: '',
        uuid: '',
    }), 2), appParams = _k[0], setAppParams = _k[1];
    /** 当前的平台 m | app | pc */
    // const [platform, setPlatform] = useState('');
    /** uuid 在m/pc端必存在 */
    var _l = __read(react_1.useState(''), 2), uuid = _l[0], setUuid = _l[1];
    var _m = __read(react_1.useState(''), 2), fromCode = _m[0], setFromcode = _m[1];
    /** 城市信息  默认北京 */
    var _o = __read(react_1.useState(function () {
        return {
            cityid: 613,
            cityname: '北京',
        };
    }), 2), cityInfo = _o[0], setCityInfo = _o[1];
    /** 车型弹窗配置信息 */
    var _p = __read(react_1.useState(), 2), prodPopConfigInfo = _p[0], setProdPopConfigInfo = _p[1];
    /** 控制车型弹窗的显示隐藏 */
    var _q = __read(react_1.useState(false), 2), showProductPop = _q[0], setShowProductPop = _q[1];
    /** 当前的车型信息 */
    var _r = __read(react_1.useState(null), 2), curProdInfo = _r[0], setCurProdInfo = _r[1];
    var _s = __read(react_1.useState(), 2), allProdList = _s[0], setAllProdList = _s[1];
    var cache_lineId = react_1.useRef('');
    /** 默认的姓名，从storage中获取 必须是对象格式否则代码会显示无限训话 */
    var _t = __read(react_1.useState({
        inputVal: '',
    }), 2), defaultNameVal = _t[0], setDefaultNameVal = _t[1];
    /** 默认的手机号，从storage中获取 */
    var _u = __read(react_1.useState({
        inputVal: '',
        encrptionVal: '',
    }), 2), defaultTelVal = _u[0], setDefaultTelVal = _u[1];
    /** 采薇信息tokenkey */
    var _v = __read(react_1.useState(''), 2), tokenKey = _v[0], setTokenKey = _v[1];
    react_1.useEffect(function () {
        // 为解决安卓5页面白屏 start
        var _a = props.visible, visible = _a === void 0 ? false : _a, _b = props.prodInfoRelate, IObject = _b === void 0 ? {} : _b, closeFun = props.closeFun, _c = props.fCode, fCode = _c === void 0 ? "test" : _c;
        var _d = prodInfoRelate.lineId, lineId = _d === void 0 ? 0 : _d, _e = prodInfoRelate.productId, productId = _e === void 0 ? 0 : _e;
        var urlParam = {};
        productId && productId != 0 && productId != -1 && (urlParam.productId = productId.toString());
        lineId && lineId != 0 && lineId != -1 && (urlParam.lineId = lineId.toString());
        visible && fCode && (urlParam.f = fCode.toString());
        var appAskpriceUrl = 'https://appsm.58che.com/58/askPrice.html?orderType=4';
        if (isLowerAndroidApp && visible && Object.keys(urlParam).length > 0) {
            appMethods_1.appMethods.goto(utils_1.tools.setUrlParam({ url: appAskpriceUrl, params: urlParam }));
            closeFun && closeFun();
        }
        // 为解决安卓5页面白屏 end
    }, [props]);
    react_1.useEffect(function () {
        if (parseInt(urlMethod_1.getUrlParam('showSuccess')) === 1) {
            setShowSuccessCom(true);
        }
        if (parseInt(urlMethod_1.getUrlParam('showPrivacy')) === 1) {
            setShowAgreePrivacy(true);
        }
        tools_1.loadScript({ url: '//ss.xgo-img.com.cn/public/js/md5.js' });
    }, []);
    react_1.useEffect(function () {
        var _a, _b;
        if ((_b = (_a = props.prodInfoRelate) === null || _a === void 0 ? void 0 : _a.defaultProdInfo) === null || _b === void 0 ? void 0 : _b.showName) {
            setNewProdInfo(props.prodInfoRelate.defaultProdInfo);
        }
    }, [(_a = props.prodInfoRelate) === null || _a === void 0 ? void 0 : _a.defaultProdInfo]);
    react_1.useEffect(function () {
        if (typeof cityRelate !== 'undefined' && cityRelate.defaultCityInfo) {
            setCityInfo(cityRelate.defaultCityInfo);
        }
    }, [cityRelate]);
    /** 默认的用户名 */
    react_1.useEffect(function () {
        if (defaultNameValProps) {
            setDefaultNameVal(function () {
                return {
                    inputVal: defaultNameValProps,
                };
            });
        }
    }, [defaultNameValProps]);
    /** 默认的手机号 */
    react_1.useEffect(function () {
        if (defaultPhoneValProps) {
            setDefaultTelVal(function () {
                var data = {
                    inputVal: defaultPhoneValProps,
                };
                if (defaultPhoneEncrption) {
                    data = __assign(__assign({}, data), { encrptionVal: defaultPhoneValProps.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') });
                }
                return data;
            });
        }
    }, [defaultPhoneValProps, defaultPhoneEncrption]);
    /** 控制获取缓存的姓名和电话, 但是props的默认值优先级大于stroage中的数据 */
    react_1.useEffect(function () {
        if (visible) {
            /** 姓名缓存 */
            if (!defaultNameValProps && utils_1.tools.getCookie(askPriceNameCookieKey)) {
                setDefaultNameVal({
                    inputVal: decodeURIComponent(utils_1.tools.getCookie(askPriceNameCookieKey)),
                });
            }
            /** 手机号缓存 */
            if (!defaultPhoneValProps && utils_1.tools.getCookie(askPricePhoneCookieKey)) {
                setDefaultTelVal({
                    inputVal: utils_1.tools.getCookie(askPricePhoneCookieKey),
                });
            }
        }
    }, [
        visible,
        defaultNameValProps,
        defaultPhoneValProps,
        askPriceNameCookieKey,
        askPricePhoneCookieKey,
    ]);
    react_1.useEffect(function () {
        /*
          如果弹窗显示 请求是否默认勾选以及默认手机号用户名以及是否显示验证码
        */
        // 如果某个浏览器第一次访问58域名地址cookie获取不到58tj_uuid 需要从storage获取
        setUuid(utils_1.tools.getCookie('58tj_uuid') || localStorage.getItem('58tj_uuid') || '');
        setFromcode(utils_1.tools.getUrlParam('from') || utils_1.tools.getCookie('from_code'));
        if (visible) {
            getSetMsgChecked();
        }
    }, [
        visible,
        messageCodeRelate.needMsgCode,
        props.fCode,
        privacyRelate,
        isUsedAppInfo,
        defaultNameValProps,
        defaultPhoneValProps,
        askPriceNameCookieKey,
        askPricePhoneCookieKey,
        isNeedCodeRelate,
    ]);
    react_1.useEffect(function () {
        /** 再次打开 如果配置项不允许成功之后再显示成功样式的时候初始化弹窗 并且url上没有强制显示成功弹窗的时候 */
        if (visible &&
            !successRelate.successAfterReshowSuccess &&
            !parseInt(urlMethod_1.getUrlParam('showSuccess'))) {
            setShowSuccessCom(false);
        }
        /** 每次重新打开弹窗都自动隐藏隐私协议的弹窗 */
        if (visible) {
            setShowAgreePrivacy(false);
        }
    }, [visible, successRelate.successAfterReshowSuccess]);
    /** 初始化车型弹窗配置，必须判断是否存在 如果传空会覆盖旧的配置 */
    react_1.useEffect(function () {
        if (prodInfoRelate) {
            if (prodInfoRelate.showProdArea) {
                var newProdPopConfig = {};
                if (prodInfoRelate.ajaxUrl) {
                    newProdPopConfig.ajaxUrl = prodInfoRelate.ajaxUrl;
                }
                if (prodInfoRelate.saveKey) {
                    newProdPopConfig.saveKey = prodInfoRelate.saveKey;
                }
                if (prodInfoRelate.lineId &&
                    prodInfoRelate.lineId !== cache_lineId.current) {
                    cache_lineId.current = prodInfoRelate.lineId;
                    setAllProdList(undefined);
                    setCurProdInfo(null);
                }
                setProdPopConfigInfo(newProdPopConfig);
            }
            // setCurProdInfo({
            //   productId: prodInfoRelate.productId,
            //   lineId: prodInfoRelate.lineId
            // })
        }
    }, [prodInfoRelate]);
    /** 获取是否需要默认勾选 */
    var getSetMsgChecked = function () {
        /** 如果是在58app内的话获取app的信息 */
        if (utils_1.tools.is58App()) {
            appMethods_1.appMethods.getUserInfo().then(function (res) {
                var userInfoData = res;
                appMethods_1.appMethods.getImei().then(function (imeiInfo) {
                    var imeiData = imeiInfo;
                    setAppParams(__assign(__assign({}, imeiData), { productorid: userInfoData.productorid, accessmode: userInfoData.accessmode || '', uuid: userInfoData.uuid || '' }));
                    // 获取是否需要验证码/默认勾选
                    getIsNeedShowCode(__assign(__assign({}, imeiData), { productorid: userInfoData.productorid, 
                        // 此参数app已经不再返回
                        accessmode: userInfoData.accessmode || '', 
                        // 此参数app已经不再返回
                        clientId: userInfoData.clientId || '', uuid: userInfoData.uuid || '', uid: userInfoData.uid || '', ppu: userInfoData.ppu || userInfoData.PPU || '', openudid: userInfoData.openudid || '', utoken: typeof window.md5 !== 'undefined'
                            ? window.md5(userInfoData.uid + 'b02O3E96$2f07e*9e7935cD4(1e3f9Ee')
                            : '' }));
                });
            });
        }
        else {
            getIsNeedShowCode({
                accessmode: '',
                productorid: '',
                ppu: '',
                xxwxtoken: '',
                xxwxtokenp: '',
                os: '',
                version: '',
                uid: '',
                openudid: '',
                clientId: '',
                utoken: '',
                uuid: utils_1.tools.getCookie('58tj_uuid') ||
                    localStorage.getItem('58tj_uuid') ||
                    '',
            });
        }
    };
    /** 获取是否需要显示验证码 是否需要默认勾选隐私协议 */
    var getIsNeedShowCode = function (appInfoParms) { return __awaiter(void 0, void 0, void 0, function () {
        var params, res, _a, userInfo_1, select_1, isNeedCode, err_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    params = __assign(__assign({ f: props.fCode, platform: utils_1.tools.getCurPlatform() }, appInfoParms), isNeedCodeRelate.ajaxParams);
                    // 测试的参数 url上携带test=1即可
                    if (parseInt(urlMethod_1.getUrlParam('test')) === 1) {
                        params = __assign(__assign({}, params), testParam_1.testParams);
                    }
                    res = void 0;
                    if (!isNeedCodeRelate.ajaxUrl) return [3 /*break*/, 2];
                    return [4 /*yield*/, request_1.request(isNeedCodeRelate.ajaxUrl, __assign({}, params), 'jsonp')];
                case 1:
                    res = _d.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, utils_1.tools.getIsNeedMsgCode(__assign({}, params))];
                case 3:
                    res = (_d.sent());
                    _d.label = 4;
                case 4:
                    /** 兼容appsm的接口格式 */
                    if (res.code === 0 && (((_b = res.entity) === null || _b === void 0 ? void 0 : _b.data) || res.data)) {
                        _a = ((_c = res === null || res === void 0 ? void 0 : res.entity) === null || _c === void 0 ? void 0 : _c.data) || (res === null || res === void 0 ? void 0 : res.data), userInfo_1 = _a.userInfo, select_1 = _a.select, isNeedCode = _a.isNeedCode;
                        /** 第一个阶段存储信息 如果用户信息存在提交采薇 */
                        if ((userInfo_1 && userInfo_1.mobile && userInfo_1.name) ||
                            (utils_1.tools.getCookie(askPricePhoneCookieKey) &&
                                utils_1.tools.getCookie(askPriceNameCookieKey))) {
                            submitCaiweiUserInfo({
                                telephone: utils_1.tools.getCookie(askPricePhoneCookieKey)
                                    ? utils_1.tools.getCookie(askPricePhoneCookieKey)
                                    : userInfo_1.mobile || '',
                                username: utils_1.tools.getCookie(askPriceNameCookieKey)
                                    ? decodeURIComponent(utils_1.tools.getCookie(askPriceNameCookieKey))
                                    : userInfo_1.name || '',
                            });
                        }
                        if (isUsedAppInfo) {
                            /** 默认姓名不存在且cookie中改不存在的话赋值 */
                            if (!defaultNameValProps) {
                                // eslint-disable-next-line max-depth
                                if (utils_1.tools.getCookie(askPriceNameCookieKey)) {
                                    setDefaultNameVal({
                                        inputVal: decodeURIComponent(utils_1.tools.getCookie(askPriceNameCookieKey)),
                                    });
                                }
                                else {
                                    setDefaultNameVal(function () {
                                        return { inputVal: (userInfo_1 === null || userInfo_1 === void 0 ? void 0 : userInfo_1.name) || '' };
                                    });
                                }
                            }
                            /** 默认手机号不存在且cookie中改不存在的话赋值 */
                            if (!defaultPhoneValProps) {
                                // eslint-disable-next-line max-depth
                                if (utils_1.tools.getCookie(askPricePhoneCookieKey)) {
                                    setDefaultTelVal({
                                        inputVal: utils_1.tools.getCookie(askPricePhoneCookieKey),
                                    });
                                }
                                else {
                                    setDefaultTelVal(function () {
                                        return { inputVal: (userInfo_1 === null || userInfo_1 === void 0 ? void 0 : userInfo_1.mobile) || '' };
                                    });
                                }
                            }
                        }
                        /** 如果不传是否默认勾选的话取 接口返回的 */
                        if (typeof privacyRelate === 'undefined' ||
                            typeof privacyRelate.defaultChecked === 'undefined') {
                            setFormData(function (prev) {
                                var _a;
                                return __assign(__assign({}, prev), (_a = {}, _a["privacy" /* 隐私协议 */] = select_1, _a));
                            });
                        }
                        else if (privacyRelate === null || privacyRelate === void 0 ? void 0 : privacyRelate.defaultChecked) {
                            setFormData(function (prev) {
                                var _a;
                                return __assign(__assign({}, prev), (_a = {}, _a["privacy" /* 隐私协议 */] = privacyRelate.defaultChecked, _a));
                            });
                        }
                        if (typeof messageCodeRelate !== 'undefined' &&
                            typeof messageCodeRelate.needMsgCode !== 'undefined') {
                            switch (messageCodeRelate.needMsgCode) {
                                case 0:
                                    setShowMsgCode(false);
                                    break;
                                case 1:
                                    setShowMsgCode(isNeedCode);
                                    break;
                                case 2:
                                    setShowMsgCode(true);
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    else {
                        throw res;
                    }
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _d.sent();
                    showError(err_1.message || err_1.msg || '获取信息失败');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    /** 提交信息到采薇系统 */
    var submitCaiweiUserInfo = function (info) {
        if (info === void 0) { info = {
            telephone: '',
            username: '',
        }; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 如果不在58app不执行
                if (!utils_1.tools.is58App() || !visible) {
                    return [2 /*return*/];
                }
                appMethods_1.appMethods.getUserInfo().then(function (resp) { return __awaiter(void 0, void 0, void 0, function () {
                    var userInfo, encyrptData, res, err_2;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                userInfo = {
                                    telephone: info.telephone || formDataRef.current["tel" /* 电话 */] || '',
                                    userName: info.username || formDataRef.current["name" /* 姓名 */] || '',
                                    userImei: appMethods_1.appMethods.isIos() ? resp.openudid : resp['58clientid'],
                                    cityId: cityInfo.cityid,
                                    lineId: (curProdInfo && curProdInfo.lineId) ||
                                        (prodInfoRelate && prodInfoRelate.lineId) ||
                                        '',
                                    productId: (curProdInfo && curProdInfo.productId) ||
                                        (prodInfoRelate && prodInfoRelate.productId) ||
                                        '',
                                    isFrom: props.fCode,
                                    type: 4,
                                    tokenKey: tokenKey || '',
                                };
                                if (!isLowerAndroidApp) return [3 /*break*/, 1];
                                encyrptData = userInfo;
                                return [3 /*break*/, 3];
                            case 1: return [4 /*yield*/, crypto_1.encryptDataFn(userInfo)];
                            case 2:
                                encyrptData = _b.sent();
                                _b.label = 3;
                            case 3:
                                _b.trys.push([3, 5, , 6]);
                                return [4 /*yield*/, request_1.request('//service.58che.com/user/v1/browselog/', {
                                        logData: encyrptData,
                                    }, 'json', {
                                        method: 'post',
                                        isCors: true,
                                        paramsType: 'formdata',
                                    })];
                            case 4:
                                res = (_b.sent());
                                if (res.code === 0 && ((_a = res.entity) === null || _a === void 0 ? void 0 : _a.data)) {
                                    setTokenKey(res.entity.data.msg);
                                }
                                else {
                                    throw res;
                                }
                                return [3 /*break*/, 6];
                            case 5:
                                err_2 = _b.sent();
                                console.log('submit info error', err_2);
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /* 点击遮罩层事件 */
    var onClickMask = react_1.useCallback(function () {
        if (allowMaskClose) {
            onClickClose();
        }
    }, [
        props.closeFun,
        showAgreePrivacy,
        showSuccessCom,
        props.onClickCloseType,
    ]);
    /** 点击关闭 按钮*/
    var onClickClose = react_1.useCallback(function () {
        setFormData(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a["privacy" /* 隐私协议 */] = undefined, _a));
        });
        /**
         * 如果打开的是未授权协议的弹窗的话 只关闭未授权隐私协议的弹窗，同时将回调函数增加类型参数回传，用于埋点等操作
         */
        var type = 'normal';
        if (showAgreePrivacy) {
            type = 'agreePrivacyModal';
            setShowAgreePrivacy(false);
            if (typeof props.onClickCloseType !== 'undefined') {
                props.onClickCloseType(type);
            }
            return;
        }
        else if (showSuccessCom) {
            type = 'successModal';
        }
        if (typeof props.onClickCloseType !== 'undefined') {
            props.onClickCloseType(type);
        }
        if (typeof props.closeFun !== 'undefined') {
            props.closeFun();
        }
    }, [
        props.closeFun,
        showAgreePrivacy,
        showSuccessCom,
        props.onClickCloseType,
    ]);
    /** inputchange事件 */
    var onChangeInput = react_1.useCallback(function (val, type) {
        setFormData(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[type] = val, _a));
        });
    }, []);
    /** 提交询价 */
    var onSubmit = function () {
        // 获取当前表单的数据
        /** 生成表单校验规则 */
        var formDataRule = [];
        /** 遍历所有的校验规则 */
        for (var item in commonData_1.formItemInfo) {
            if (item !== "code" /* 验证码 */ ||
                (item === "code" /* 验证码 */ && showMsgCode)) {
                if (bannedDisplayModule.indexOf(item + '') > -1) {
                    // 禁用模块不参与参数校验
                    // console.log("bannedDisplayModule", bannedDisplayModule, item);
                }
                else {
                    formDataRule.push(__assign({ value: formDataRef.current && formDataRef.current[item]
                            ? formDataRef.current[item]
                            : '' }, commonData_1.formItemInfo[item].ruleData));
                }
            }
        }
        if (props.cityinfoRelate && props.cityinfoRelate.show) {
            formDataRule.push({
                value: cityInfo && cityInfo.cityname ? cityInfo.cityname : '',
                id: "cityinfo" /* 城市 */,
                rule: 'empty',
                require: true,
            });
        }
        utils_1.tools.checkForm(formDataRule).then(function () {
            // 前端验证通过
            onSubmitAjax();
        }, function (id) {
            // 弹提示
            var tipStr = '';
            switch (id) {
                case "name" /* 姓名 */:
                    tipStr = '请输入您的称呼';
                    break;
                case "tel" /* 电话 */:
                    tipStr = '请输入正确的手机号';
                    break;
                case "code" /* 验证码 */:
                    tipStr = '请输入手机验证码';
                    break;
                case "privacy" /* 隐私协议 */:
                    // 第二个阶段调用接口存储信息
                    submitCaiweiUserInfo();
                    setShowAgreePrivacy(true);
                    return;
                case "cityinfo" /* 城市 */:
                    tipStr = '请选择城市';
                    break;
                default:
                    break;
            }
            showError(tipStr);
        });
    };
    /** 提交询价接口逻辑 */
    var onSubmitAjax = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, checkFnData, ajaxUrl, res, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof props.fCode === 'undefined') {
                        showError('缺少必传参数FCode');
                        return [2 /*return*/];
                    }
                    params = __assign(__assign(__assign({}, appParams), { 
                        // productId 如果页面展示了车型信息说明curProdInfo有值，否则取 prodInfoRelate
                        productId: (curProdInfo && curProdInfo.productId) ||
                            (prodInfoRelate && prodInfoRelate.productId) ||
                            '', lineId: (curProdInfo && curProdInfo.lineId) ||
                            (prodInfoRelate && prodInfoRelate.lineId) ||
                            '', name: formDataRef.current["name" /* 姓名 */] || '', phone: formDataRef.current["tel" /* 电话 */] || '', phoneCode: formDataRef.current["code" /* 验证码 */] || '', f: props.fCode || '', fromCode: fromCode, cityId: cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityid, platform: utils_1.tools.getCurPlatform(), 
                        // 0 不需要验证码，1：需要判断是否需要验证验证码（也可能不需要验证码）
                        checkType: messageCodeRelate.needMsgCode, 
                        // type 不是app的时候必传
                        uuid: utils_1.tools.is58App() ? appParams.uuid : uuid, 
                        // 采薇用户信息token
                        potentialLeadsEncryptId: tokenKey || '' }), submitRelate.ajaxParams);
                    if (typeof props.submitRelate !== 'undefined' &&
                        typeof props.submitRelate.onSubmitCheckedFn !== 'undefined') {
                        checkFnData = props.submitRelate.onSubmitCheckedFn(params);
                        if (typeof checkFnData === 'boolean' && !!!checkFnData) {
                            return [2 /*return*/];
                        }
                    }
                    if (submitLoadingRef.current) {
                        return [2 /*return*/];
                    }
                    setSubmitLoding(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    ajaxUrl = submitRelate.ajaxUrl;
                    return [4 /*yield*/, request_1.request(ajaxUrl, __assign({}, params), submitRelate.ajaxType, __assign({ method: submitRelate.ajaxMethod, isCors: true, paramsType: submitRelate.ajaxSubmitContentType }, submitRelate.ajaxOtherParam))];
                case 2:
                    res = (_a.sent());
                    if (res.code === 0) {
                        formDataRef.current["name" /* 姓名 */] &&
                            utils_1.tools.setCookie({
                                name: askPriceNameCookieKey,
                                path: '/',
                                domain: cookieDomainName,
                                value: encodeURIComponent(formDataRef.current["name" /* 姓名 */]),
                                expiredays: 7,
                            });
                        formDataRef.current["tel" /* 电话 */] &&
                            utils_1.tools.setCookie({
                                name: askPricePhoneCookieKey,
                                path: '/',
                                domain: cookieDomainName,
                                value: formDataRef.current["tel" /* 电话 */],
                                expiredays: 7,
                            });
                        if (typeof props.submitRelate !== 'undefined' &&
                            typeof props.submitRelate.onSubmitSuccessFn !== 'undefined') {
                            /** 在这里promise里面处理成功弹窗组件或者是其他的操作 */
                            props.submitRelate
                                .onSubmitSuccessFn(params, res)
                                .then(function () {
                                setShowAgreePrivacy(false);
                                setShowSuccessCom(true);
                                setSubmitLoding(false);
                            })
                                .catch(function (err) {
                                if (err === 'jump') {
                                }
                                else {
                                    showError(err || '询价失败');
                                    setSubmitLoding(false);
                                }
                            });
                        }
                        else {
                            setSubmitLoding(false);
                            setShowAgreePrivacy(false);
                            setShowSuccessCom(true);
                        }
                    }
                    else {
                        throw res;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_3 = _a.sent();
                    setSubmitLoding(false);
                    if (typeof submitRelate !== 'undefined' &&
                        typeof props.submitRelate.onSubmitErrorFn !== 'undefined') {
                        props.submitRelate.onSubmitErrorFn(params, err_3, showError);
                    }
                    else {
                        showError(err_3.message || err_3.msg || '提交失败，未知错误');
                        /** 如果当前处于是否同意勾选隐私协议弹窗，则关闭 */
                        if (showAgreePrivacy) {
                            setShowAgreePrivacy(false);
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /* 隐藏弱提示 */
    var hidePrompt = react_1.useCallback(function () {
        setPromptShow(false);
    }, [promptShow]);
    /** 改变勾选隐私协议的状态 */
    var onChangePrivacy = react_1.useCallback(function (status) {
        return new Promise(function (resolve, reject) {
            setFormData(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a["privacy" /* 隐私协议 */] = status, _a));
            });
            resolve('success');
        });
    }, [formData]);
    /** 设置错误提示信息 */
    var onGetMessageError = react_1.useCallback(function (error) {
        showError(error);
    }, []);
    /** 显示错误提示信息 */
    var showError = react_1.useCallback(function (str) {
        // 显示错误信息
        setPromptShow(true);
        setPromptTip(str);
    }, []);
    // 设置城市信息
    var setCityInfoFun = react_1.useCallback(function (data) {
        setCityInfo({
            cityname: data.name,
            cityid: data.cid,
        });
        if (typeof props.cityinfoRelate !== 'undefined' &&
            typeof props.cityinfoRelate.selectedCityFn !== 'undefined') {
            props.cityinfoRelate.selectedCityFn(data);
        }
        setCityPopShow(false);
    }, [props.cityinfoRelate]);
    /** 显示选择城市弹窗 */
    var onShowSelectCity = react_1.useCallback(function () {
        setCityPopShow(true);
    }, []);
    /** 关闭选择城市弹窗 */
    var onCloseSelectCity = react_1.useCallback(function () {
        if (typeof props.cityinfoRelate !== 'undefined' &&
            typeof props.cityinfoRelate.closeCityFn !== 'undefined') {
            props.cityinfoRelate.closeCityFn();
        }
        setCityPopShow(false);
    }, [props.cityinfoRelate]);
    /** 初始化默认的车型信息，只在第一次的时候或者是改变了lineId之后，其余更新车型信息均在切换车型里面处理 */
    react_1.useEffect(function () {
        if (typeof allProdList !== 'undefined') {
            var obj = void 0, item = void 0;
            for (var i = 0; i < Object.keys(allProdList).length; i++) {
                if (allProdList &&
                    Object.keys(allProdList)[i] &&
                    allProdList[Object.keys(allProdList)[i]]) {
                    obj = allProdList[Object.keys(allProdList)[i]];
                }
                for (var j = 0; j < obj.length; j++) {
                    if ((!prodInfoRelate.productId && j == 0) ||
                        (prodInfoRelate.productId &&
                            obj[j].productId == prodInfoRelate.productId)) {
                        item = obj[j];
                        break;
                    }
                }
                if (item) {
                    break;
                }
            }
            // 初始化第一次把当前的车型信息返回
            if (item &&
                typeof props.prodInfoRelate !== 'undefined' &&
                typeof props.prodInfoRelate.selectProdCallback == 'function') {
                props.prodInfoRelate.selectProdCallback(item);
            }
            setCurProdInfo(item);
        }
    }, [allProdList]);
    /** 用于初始化和切换 */
    var getAllProductInfo = react_1.useCallback(function (data) {
        /** 如果车型id 不存在或者是-1的时候默认选择第一个 */
        if (!allProdList) {
            setAllProdList(data);
        }
    }, [allProdList]);
    /** 选中车型 */
    var changeProductFun = react_1.useCallback(function (data) {
        onCloseProductPop();
        setCurProdInfo(data);
        if (typeof props.prodInfoRelate.selectProdCallback !== 'undefined') {
            props.prodInfoRelate.selectProdCallback(data);
        }
    }, [props.prodInfoRelate]);
    /** 设置新的prodInfo */
    var setNewProdInfo = function (data) {
        setCurProdInfo(data);
    };
    /** 显示切换车型弹窗 */
    var onShowProductPop = react_1.useCallback(function () {
        setShowProductPop(true);
    }, []);
    /** 关闭切换车型弹窗 */
    var onCloseProductPop = react_1.useCallback(function () {
        setShowProductPop(false);
    }, []);
    /** 未勾选隐私协议提示弹窗，点击确认 */
    var onAgreePrivacy = function () {
        if (typeof props.onClickAgreePrivacyBtn !== 'undefined') {
            props.onClickAgreePrivacyBtn();
        }
        // 设置勾选隐私协议成功
        onChangePrivacy(true).then(function (res) {
            if (res === 'success') {
                onSubmit();
            }
        });
    };
    /** 渲染城市弹窗 */
    var renderCityPop = react_1.useCallback(function () {
        if (cityRelate && cityRelate.show) {
            return (react_1.default.createElement(CityPop_1.CityPop, { cn: typeof cityRelate !== 'undefined' && cityRelate.cn
                    ? cityRelate.cn
                    : 'select-city-modal', show: cityPopShow, selected: cityInfo && cityInfo.cityid ? cityInfo.cityid : '', closeFun: onCloseSelectCity, callbackFun: setCityInfoFun }));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    }, [cityRelate, cityPopShow, cityInfo]);
    /** 渲染切换车型 */
    var renderSelectProdPop = react_1.useCallback(function () {
        /* 车型选择区域 如果自定义顶部插槽则不获取车型信息 */
        if (!topSlotNode && prodInfoRelate && prodInfoRelate.showProdArea) {
            return (react_1.default.createElement(ProductPop_1.ProductPop, __assign({ lineId: curProdInfo ? curProdInfo.lineId : prodInfoRelate.lineId, show: showProductPop, productId: curProdInfo ? curProdInfo.productId : prodInfoRelate.productId }, (prodPopConfigInfo || {}), { closeFun: onCloseProductPop, callbackFun: changeProductFun, getDataCallbackFun: getAllProductInfo }, prodInfoRelate.otherOpts)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    }, [topSlotNode, prodInfoRelate, showProductPop, curProdInfo]);
    /** 成功询价的组件 */
    var renderSuccessArea = react_1.useCallback(function () {
        if (successRelate && successRelate.successComNode) {
            return successRelate.successComNode;
        }
        else {
            return (react_1.default.createElement(successCom_1.default, { successRelate: successRelate, onClickClose: onClickClose }));
        }
    }, [successRelate]);
    /** 跳转到隐私协议页面 */
    var onGoPrivacyPage = react_1.useCallback(function () {
        if (utils_1.tools.is58App()) {
            appMethods_1.appMethods.goto(commonData_1.infoAuthorizaUrl);
        }
        else {
            window.location.href = commonData_1.infoAuthorizaUrl;
        }
    }, []);
    /** 渲染隐私协议的弹窗 */
    var renderPrivacyModal = function () {
        return (react_1.default.createElement("div", { className: 'privacy-modal' },
            react_1.default.createElement("div", { className: 'privacy-modal-maintitle' }, privacyModalRelate.topTitle || '完成咨询只差一步'),
            react_1.default.createElement("div", { className: 'privacy-modal-subtitle' },
                privacyModalRelate.privacyMainTitle ||
                    '我们致力于保护您的个人信息，完成询价咨询需要您同意',
                react_1.default.createElement("div", { style: {
                        color: '#ff552e',
                        cursor: 'pointer',
                        display: 'inline-block',
                    }, onClick: onGoPrivacyPage }, privacyModalRelate.privacyLinkTitle ||
                    '《个人信息授权书及保护声明》')),
            react_1.default.createElement("div", { className: 'privacy-modal-accept-btn', onClick: onAgreePrivacy }, privacyModalRelate.btnTitle || '好的，完成询价')));
    };
    return (isLowerAndroidApp ?
        react_1.default.createElement(react_1.default.Fragment, null) :
        react_1.default.createElement(modal_1.default, { visible: visible, cn: "" + modalCn, allowMaskCloseFn: onClickMask, autoScrollId: props.autoScrollId || null, direction: props.direction || 'toUp', needAnimation: typeof props.needAnimation === 'undefined' ? props.needAnimation : true, otherDom: react_1.default.createElement(react_1.default.Fragment, null,
                renderCityPop(),
                renderSelectProdPop()) },
            react_1.default.createElement("div", { className: "newcar-askcontent " + contentCn },
                react_1.default.createElement("div", { className: 'newcar-inner-wrap' },
                    showCloseIcon && (react_1.default.createElement("div", { className: 'newcar-askcontent-close', onClick: onClickClose },
                        react_1.default.createElement("img", { src: '//icon.xgo-img.com.cn/article/22051715/xinche_close.png', alt: 'close' }))),
                    showAgreePrivacy && renderPrivacyModal(),
                    showSuccessCom && renderSuccessArea(),
                    react_1.default.createElement("div", { style: {
                            display: showAgreePrivacy || showSuccessCom ? 'none' : 'block',
                        } },
                        titleRelate.mainTitleShow && (react_1.default.createElement("div", { className: 'newcar-askcontent-title' }, (titleRelate && titleRelate.mainTitle) || '获取底价')),
                        titleRelate && titleRelate.subTitle && (react_1.default.createElement("div", { className: 'newcar-askcontent-subtitle' }, (titleRelate && titleRelate.subTitle))),
                        topSlotNode && topSlotNode,
                        !topSlotNode &&
                            typeof prodInfoRelate !== 'undefined' &&
                            prodInfoRelate.showProdArea && (react_1.default.createElement(productArea_1.default, { productInfo: curProdInfo, autoClickProArea: prodInfoRelate.autoClickPro || null, 
                            /** 控制展示选中车型的callback  */
                            showSelectPop: typeof prodInfoRelate.showSelectPop === 'boolean' &&
                                prodInfoRelate.showSelectPop === true
                                ? onShowProductPop
                                : false })),
                        midSlotNode && midSlotNode,
                        react_1.default.createElement("form", { className: 'newcar-askcontent-form' },
                            react_1.default.createElement("input", { type: "text", value: "\u9632\u6B62from\u53EA\u6709\u4E00\u4E2Ainput\u56DE\u8F66\u5237\u65B0\u9875\u9762\u95EE\u9898", style: { display: "none" } }),
                            bannedDisplayModule.indexOf('name') == -1 && (react_1.default.createElement(InputRow_1.RealnameRow, __assign({}, commonData_1.formItemInfo["name" /* 姓名 */].autoConfig, { inputFun: function (val) {
                                    return onChangeInput(val, "name" /* 姓名 */);
                                }, isAutoComplete: true, defaultValObj: defaultNameVal }))),
                            bannedDisplayModule.indexOf('tel') == -1 && (react_1.default.createElement(InputRow_1.TelRow, __assign({}, commonData_1.formItemInfo["tel" /* 电话 */].autoConfig, { inputFun: function (val) {
                                    return onChangeInput(val, "tel" /* 电话 */);
                                }, isAutoComplete: true, defaultValObj: defaultTelVal }))),
                            showMsgCode && bannedDisplayModule.indexOf('code') == -1 && (react_1.default.createElement(InputRow_1.MessageCodeRow, __assign({ tel: formData && formData["tel" /* 电话 */]
                                    ? formData["tel" /* 电话 */]
                                    : '', 
                                // phone
                                ajaxKey: 'phone', inputFun: function (val) {
                                    return onChangeInput(val, "code" /* 验证码 */);
                                }, errorFun: onGetMessageError, 
                                /** 发送验证码的 */
                                ajaxUrl: messageCodeRelate.ajaxUrl, ajaxParams: __assign(__assign(__assign({}, appParams), { platform: utils_1.tools.getCurPlatform(), uuid: uuid }), messageCodeRelate.ajaxParams) }, commonData_1.formItemInfo["code" /* 验证码 */].autoConfig))),
                            cityRelate && cityRelate.show && (react_1.default.createElement("div", { className: 'newcar-askcontent-form-city' },
                                react_1.default.createElement("label", null, "\u57CE\u5E02"),
                                react_1.default.createElement("div", { className: 'newcar-askcontent-form-city-info', onClick: onShowSelectCity },
                                    react_1.default.createElement("span", null, cityInfo && cityInfo.cityname ? cityInfo.cityname : ''),
                                    react_1.default.createElement("img", { className: 'more-icon', src: '//icon.xgo-img.com.cn/article/22051716/xinche_rightarrow.png', alt: '' })))),
                            react_1.default.createElement("div", { className: 'newcar-askcontent-form-privacy' }, typeof window !== 'undefined' &&
                                bannedDisplayModule.indexOf('privacy') == -1 && (react_1.default.createElement(InputRow_1.RadioRow, { default: formData && formData["privacy" /* 隐私协议 */]
                                    ? formData["privacy" /* 隐私协议 */]
                                    : false, callback: onChangePrivacy, cn: 'privacy-wrap' }, privacyRelate && privacyRelate.privacyNode ? (privacyRelate.privacyNode) : (react_1.default.createElement(react_1.default.Fragment, null,
                                "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F",
                                react_1.default.createElement("div", { className: 'link-url', onClick: onGoPrivacyPage }, "\u300A\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u4E66\u53CA\u4FDD\u62A4\u58F0\u660E\u300B"))))))),
                        bannedDisplayModule.indexOf('submit') == -1 && (react_1.default.createElement("div", { className: 'newcar-askcontent-submit', onClick: onSubmit },
                            react_1.default.createElement("div", { className: 'newcar-askcontent-submit-inner' },
                                react_1.default.createElement("div", { className: 'newcar-askcontent-submit-inner-maintext' }, titleRelate.btnMainTitle || '立即询价'),
                                titleRelate.btnSubTitle && (react_1.default.createElement("div", { className: 'newcar-askcontent-submit-inner-subtext' }, titleRelate.btnSubTitle))))),
                        (titleRelate === null || titleRelate === void 0 ? void 0 : titleRelate.btnBotTitle) &&
                            bannedDisplayModule.indexOf('submit') == -1 && (react_1.default.createElement("div", { className: 'newcar-askcontent-btn-subtitle' }, titleRelate.btnBotTitle))),
                    react_1.default.createElement(Prompt_1.Prompt, { show: promptShow, tipStr: promptTip, cn: 'newcar_ui_errorTip', closeFun: hidePrompt })))));
});
Index.defaultProps = {
    visible: false,
    allowMaskClose: false,
    titleRelate: {
        mainTitle: '',
        subTitle: '',
        btnSubTitle: '',
        btnMainTitle: '',
        mainTitleShow: true,
    },
    privacyModalRelate: {
        topTitle: '',
        privacyLinkTitle: '',
        privacyMainTitle: '',
        btnTitle: '',
    },
    modalCn: '',
    showCloseIcon: true,
    contentCn: '',
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
